import React from 'react'

const KnowledgeData = [
    "MVC",
    "ASP.Net",
    "C#",
    "Entity Framework",
    "ASP.Net Core",
    "Restfull Web Api",
    "Azure",
    "Devops",
    "React",
    "Typescript",
    "Git",
    "Machine Learning",
    "Team Player",
    "Good Communication Skills",
    "Leadership",
    "High Grasping",
]

const Knowledge = () => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
            <div className="skills-list list">
                <div className="skill-title border-line-h">
                    <div className="icon"><i className="fa fa-list"></i></div>
                    <div className="name">Knowledge</div>
                </div>
                <ul>
                    {
                        KnowledgeData.map(data =>
                            <li><div className="name">{data}</div></li>
                        )
                    }
                </ul>
            </div>
        </div>
    );
}

export default Knowledge;